import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AnonymousIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="m13.04 6.428-1.854-3.637c-.308-.605-.908-1.006-1.586-1.006H6.4c-.678 0-1.278.401-1.587 1.006L2.96 6.428H1.143a.5.5 0 0 0 0 1h13.714a.5.5 0 0 0 0-1zm-8.306 3.5c-.764 0-1.459.692-1.459 1.643 0 .95.695 1.643 1.46 1.643.764 0 1.459-.693 1.459-1.643s-.695-1.643-1.46-1.643m-2.459 1.643c0-1.417 1.06-2.643 2.46-2.643 1.23 0 2.2.95 2.414 2.143H8.85c.215-1.193 1.184-2.143 2.415-2.143 1.4 0 2.46 1.226 2.46 2.643s-1.06 2.643-2.46 2.643c-1.231 0-2.2-.95-2.415-2.143h-1.7c-.216 1.193-1.184 2.143-2.416 2.143-1.399 0-2.459-1.227-2.459-2.643m8.99-1.643c-.765 0-1.46.692-1.46 1.643 0 .95.695 1.643 1.46 1.643s1.46-.693 1.46-1.643-.695-1.643-1.46-1.643"
			clipRule="evenodd"
		></path>
	</svg>
))
